import { Icon, IconButton } from '@atom/mui';
import { HelpIcon } from '@atom/mui/icons';
import { setWorkTimeDisplay } from '@atom/utilities/timeUtilities';

import classes from './workTemplateTaskDetail.module.css';

const styles = {
  iconButton: {
    width: '1rem',
    height: '1rem',
    padding: '0 0 0.2rem 0',
  },
  icon: {
    fontSize: '1rem',
  },
};

const TaskWorkTime = () => {
  const tooltipContent = (
    <div className={classes.tooltipContent}>
      <div>Total labor time for this task.</div>
    </div>
  );

  return (
    <div className={classes.timeRowItem}>
      <div className={classes.labelContainer}>
        <div className={classes.label}>Work Time</div>
        <IconButton tooltip={tooltipContent} style={styles.iconButton}>
          <Icon style={styles.icon} icon={HelpIcon} />
        </IconButton>
      </div>
      <div className={classes.dateDisplay}>{setWorkTimeDisplay(0)}</div>
    </div>
  );
};

export default TaskWorkTime;
